import { SCHEDULE_MESSAGES } from "../../../../../constants/no-record-found/schedule";
import { NoRecordFound, NoRecordType } from "../../../../../models/common/table/table-config";

export const noRecordFound: NoRecordFound = {
    type: NoRecordType.BASIC,
    title: SCHEDULE_MESSAGES.SHIFT_BREAK_ACTUAL_DETALIS_NO_RECORD_TITLE,
    message: '',
    show: true,
    iconSVG: 'assets/media/iq-svg/animation/schedule/shift_break_details.json',
    iconSVGClass: '',
  }